import { Button, Form, Input, Timeline, Tooltip, Typography } from 'antd';
import { TRANSFER_ORDER_STATUS } from 'constants/constants';
import { isNull, orderBy } from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DynamicObjectType } from 'types/commons';
import { formatDateTime } from 'utils/formattedString';
import { CardWrapper } from './styles';
import { useDispatch } from '@redux';
import { comment } from '@redux/orders/actions';
import { getAllOrderReturnHistories } from '@redux/orderReturnHistories/actions';
import styled from 'styled-components';

const getStatusText = ({ item }) => {
  return item?.text;
};

const OrderHistories = ({ data }: DynamicObjectType) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const onSubmit = (values) => {
    dispatch(
      comment({
        data: {
          ...values,
          id: data?.id,
        },
      }),
    ).then(() => {
      form.resetFields();
      dispatch(
        getAllOrderReturnHistories({
          data: {
            pageSize: 20,
            join: ['creator'],
            filters: [
              {
                condition: 'and',
                key: 'returnId',
                operator: 'is',
                value: data?.id,
              },
            ],
          },
          options: {
            isRefresh: true,
          },
        }),
      );
    });
  };

  const handleShowComment = (data) => {
    return (
      <Tooltip title={`${data?.comment || ''}`} placement="topLeft">
        <Typography.Paragraph ellipsis={{ rows: 2 }}>
          {`${data.creator?.firstName || ''} ${data.creator?.lastName || ''}: ${data?.comment || ''}`}
        </Typography.Paragraph>
      </Tooltip>
    );
  };

  const getHistories = () => {
    return orderBy(data?.histories, ['createdAt'], ['desc'])?.map((e) => {
      const currentStatus = TRANSFER_ORDER_STATUS[e.status];
      return {
        // label: formatDateTime(e.createdAt),
        children: (
          <div>
            <div className="time-point">{formatDateTime(e.createdAt)}</div>
            <div className="font-semibold">
              {t(getStatusText({ item: currentStatus }))}
            </div>
            <div
              className={`${e?.creatorId ? '' : 'text-secondary'} mt-[10px]`}
            >
              {e?.creatorId ? (
                handleShowComment(e)
              ) : (
                <span
                  className={`${isNull(e?.status) ? 'text-[#000] font-semibold' : ''}`}
                >
                  <Tooltip title={e?.comment || ''} placement="topLeft">
                    <Typography.Paragraph
                      ellipsis={{ rows: 2 }}
                      className="text-secondary"
                    >
                      {e?.comment || ''}
                    </Typography.Paragraph>
                  </Tooltip>
                </span>
              )}
              <div className="mt-1">
                {e?.note ? <>Note: {e?.note}</> : null}
              </div>
            </div>
          </div>
        ),
      };
    });
  };

  return (
    <CardWrapper title={t('ordersReturn.histories')}>
      <Form form={form} onFinish={onSubmit}>
        <div className="d-flex w-full mt-[10px]">
          <Form.Item name="comment" noStyle>
            <Input
              placeholder="Add comment"
              suffix={
                <Button
                  htmlType="button"
                  type="primary"
                  onClick={() => form.submit()}
                >
                  {t('button.add')}
                </Button>
              }
            />
          </Form.Item>
        </div>
      </Form>
      <TimelineStyles
        className="mt-[40px]"
        mode="left"
        items={getHistories()}
      ></TimelineStyles>
    </CardWrapper>
  );
};

export default OrderHistories;

const TimelineStyles = styled(Timeline)`
  padding-left: 150px;

  .time-point {
    position: absolute;
    left: -160px;
  }
`;
